import {
  Msg,
  PidTagBody,
  PidTagBodyHtml,
  PidTagSubject,
  PidTagSenderEmailAddress,
} from 'msg-parser'
import { getJobIdFromText } from '../dropbox/helpers'

const isMagnoEmail = (email: string | undefined) =>
  email?.trim().toLowerCase().endsWith('@magno-it.nl')

const getMessageProperty = (msg: Msg, property: any): string | undefined => {
  const propertyInfo = msg.propertiesStream().findProperty(property)
  if (!propertyInfo) {
    return undefined
  }
  return msg.getProperty(propertyInfo.propertyTag())
}

const stripHtml = (value: string) => value.replace(/<[^>]*>/g, ' ')

const getCandidateEmailFromBody = (body: string | undefined) => {
  if (!body) {
    return undefined
  }

  const emails = stripHtml(body).match(
    /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi
  )

  return emails?.find((email) => !isMagnoEmail(email))
}

export const getMetadata = (data: ArrayBuffer) => {
  try {
    const msg = Msg.fromUint8Array(new Uint8Array(data))
    const subject = getMessageProperty(msg, PidTagSubject) || ''
    const jobId = getJobIdFromText(subject)
    const senderEmail = getMessageProperty(msg, PidTagSenderEmailAddress)
    const body =
      getMessageProperty(msg, PidTagBody) ||
      getMessageProperty(msg, PidTagBodyHtml)
    const bodyEmail = getCandidateEmailFromBody(body)
    return {
      jobId,
      email: isMagnoEmail(senderEmail) ? bodyEmail : senderEmail,
    }
  } catch (e) {
    console.error(e)
    return { jobId: undefined, email: undefined }
  }
}
